import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useMatches, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Carousel, Layout } from "antd";
import {
  STORAGE_KEYS,
  USER_TYPE,
  WORKSPACE_USER_TYPE,
} from "constants/appConstant";
import i18next from "i18next";
import { AuthInfo, clearAuthData, isLoggedIn } from "stores/slices/auth";
import { changeLayout, getLayoutConsole } from "stores/slices/layout";
import { doGetNoticeDisplay, fecthNoticeDisplay } from "stores/slices/notice";
import {
  reduceUnReadNotification,
  resetNotificationCount,
} from "stores/slices/notification";
import { setWorkspace } from "stores/slices/workspace";
import { auth } from "useFirebase/firebase";
import { requestSignInWithCustomToken } from "useFirebase/useFireStore";
import StorageHelper from "utils/storeHelper";

import ModalForm from "components/forms/components/modalForm";
import Header from "components/header";
import OperatorHeader from "components/operator/header";
import OperatorSidebar from "components/operator/sidebar";
import Sidebar from "components/sidebar";

import { PERMISSION_TYPE } from "../constants";

import styles from "./styles.module.scss";

const contentStyle = {
  height: "250px",
  overflowY: "auto",
  color: "black",
  background: "#fff",
};
const HomeLayout = () => {
  const dispatch = useDispatch();
  const matches = useMatches();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const location = useLocation();
  const { pathname } = location;

  const isAuthenticated = useSelector(isLoggedIn);
  const currentLayout = useSelector(getLayoutConsole);
  const getListNotice = useSelector(fecthNoticeDisplay);

  const [listNotice, setListNotice] = useState([]);

  // const cacheLayout = StorageHelper.getLocalItem(STORAGE_KEYS.layout);
  const authInfo = useSelector(AuthInfo);
  const [collapsed, setCollapsed] = useState(false);

  const [broken, setBroken] = useState(false);
  const [isAccess, setIsAccess] = useState(false);

  const [currentMenu, setCurrentMenu] = useState("");

  const token = StorageHelper.getCookie(STORAGE_KEYS.token);
  const [isOpenModalNotice, setIsOpenModalNotice] = useState(false);
  const [isShowed, setIsShowed] = useState(false);

  useEffect(() => {
    if (authInfo.type === USER_TYPE.USER && authInfo.workspaceRole !== null) {
      dispatch(reduceUnReadNotification({ type: "NOTICE" }));
    }
  }, [authInfo]);

  useEffect(() => {
    if (!authInfo || !authInfo.id) {
      navigate("/auth/sign-in");
      return;
    }
    console.log("pathname", pathname);
    if (
      authInfo.type === USER_TYPE.SUPER_ADMIN &&
      !pathname.includes("/admin")
    ) {
      dispatch(changeLayout("ADMIN"));
    }
    if (authInfo.type === USER_TYPE.USER) {
      if (pathname.includes("admin") && currentLayout !== "ADMIN") {
        dispatch(changeLayout("ADMIN"));
      }
      if (!pathname.includes("admin") && currentLayout === "ADMIN") {
        dispatch(changeLayout("OPERATOR"));
      }
    }
    // if (authInfo.type ) {
    //   // dispatch(changeLayout(`${authInfo.type}`));
    // } else {
    //   dispatch(changeLayout(`${currentLayout}`));
    // }
  }, []);

  useEffect(() => {
    if (!authInfo || !authInfo.id) {
      navigate("/auth/sign-in");
      setIsAccess(false);
      return;
    }
    if (currentLayout === "ADMIN") {
      if (!location.pathname.includes("admin")) {
        navigate("/admin/dashboard");
      }
    } else {
      if (location.pathname.includes("admin")) {
        if (authInfo.workspaceRole) {
          navigate("/inbox/messages");
        } else {
          navigate("/profile");
        }
      }
    }
    setIsAccess(true);
  }, [currentLayout, location]);

  useEffect(() => {
    if (!authInfo || !authInfo.id) {
      navigate("/auth/sign-in");
      setIsAccess(false);
      return;
    }
    // handle role permission
    let userPermissionType = PERMISSION_TYPE.FREE_USER;
    if (authInfo.type === USER_TYPE.SUPER_ADMIN) {
      userPermissionType = PERMISSION_TYPE.SUPER_ADMIN;
    } else {
      if (authInfo.workspaceRole === WORKSPACE_USER_TYPE.ADMIN) {
        userPermissionType = PERMISSION_TYPE.WORKSPACE_ADMIN;
      }
      if (authInfo.workspaceRole === WORKSPACE_USER_TYPE.OPERATOR) {
        userPermissionType = PERMISSION_TYPE.WORKSPACE_OPERATOR;
      }
    }
    const routePermission = matches.find(
      match => match.pathname === location.pathname
    )?.handle?.permission;

    if (routePermission && routePermission.indexOf(userPermissionType) === -1) {
      toast.error(i18next.t(`error.PERMISSION_DENIED`));
      currentLayout === "ADMIN" && navigate("/admin/dashboard");
      currentLayout === "OPERATOR" && navigate("/profile");
    }
    // Get current URL and set current URL for sidebar menu
    let currentUrl;
    if (currentLayout === "ADMIN") {
      currentUrl = location.pathname.split("/")[2];
      if (currentUrl === "workspaces") {
        const subPath = location.pathname.split("/")[3];
        if (subPath) {
          currentUrl = null;
        }
      } else if (currentUrl === "customer") {
        const subPath = location.pathname.split("/")[4];
        if (subPath !== "all") {
          currentUrl = "broadcast-list";
        }
      } else if (currentUrl === "subscription") {
        const subPath = location.pathname.split("/")[3];
        if (subPath) {
          currentUrl = null;
        }
      } else if (currentUrl === "setting") {
        const subPath = location.pathname.split("/")[3];
        if (subPath) {
          currentUrl = null;
        }
      } else if (currentUrl === "notice") {
        const subPath = location.pathname.split("/")[3];
        if (subPath) {
          currentUrl = null;
        }
      }
    }
    if (!currentUrl) {
      // OPERATOR and 1 path
      currentUrl = location.pathname.split("/")[1];
      if (currentUrl === "broadcast-list") {
        const subPath = location.pathname.split("/")[2];
        if (subPath) {
          currentUrl = null;
        }
      }
    }
    setCurrentMenu(currentUrl);
    setIsAccess(true);
  }, [location]);

  useEffect(() => {
    if (!token) {
      dispatch(clearAuthData());
      dispatch(setWorkspace(null));
      dispatch(resetNotificationCount());
      setIsAccess(false);
    }
  }, [token]);

  useEffect(() => {
    if (!isAuthenticated) {
      console.log("check clear cache");
      navigate("/auth/sign-in");
    } else {
      const user = JSON.parse(StorageHelper.getLocalItem(STORAGE_KEYS.user));
      if (user && user.fsToken) {
        requestSignInWithCustomToken(auth, user.fsToken);
      }
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (
      isAuthenticated &&
      authInfo.type === USER_TYPE.USER &&
      authInfo.workspaceRole
    ) {
      dispatch(resetNotificationCount());
      dispatch(doGetNoticeDisplay());
    }
    if (!isAuthenticated && !authInfo.workspaceRole) {
      navigate("/auth/sign-in");
    }
  }, [isAuthenticated, authInfo]);

  useEffect(() => {
    if (getListNotice && isAuthenticated) {
      setListNotice(getListNotice);
    } else {
      setListNotice([]);
    }
  }, [getListNotice, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      if (listNotice && listNotice.length > 0) {
        if (authInfo.type !== USER_TYPE.SUPER_ADMIN && authInfo.workspaceRole) {
          if (!isShowed) {
            setIsOpenModalNotice(true);
            setIsShowed(true);
          }
        }
      }
    } else {
      setListNotice([]);
    }
  }, [isAuthenticated, authInfo, listNotice, isShowed]);

  const renderTitle = () => {
    return (
      <div style={{ textAlign: "center", fontSize: 16 }}>
        {t("noticeBoard.notice")}
        <hr />
      </div>
    );
  };

  return (
    <Layout className={styles.homeLayout}>
      {currentLayout === "ADMIN" ? (
        <Sidebar
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          broken={broken}
          setBroken={setBroken}
          currentMenu={currentMenu}
          setCurrentMenu={setCurrentMenu}
          location={location}
        />
      ) : (
        <OperatorSidebar
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          broken={broken}
          setBroken={setBroken}
          currentMenu={currentMenu}
          setCurrentMenu={setCurrentMenu}
          location={location}
        />
      )}

      <Layout.Content
        style={{
          marginLeft: collapsed ? 50 : 250,
          overflowX: "hidden",
        }}
      >
        {currentLayout === "ADMIN" ? (
          <div>
            <Header
              collapsed={collapsed}
              setCollapsed={setCollapsed}
              broken={broken}
              currentMenu={currentMenu}
            />
            <div className={styles.outLetLayout}>{isAccess && <Outlet />}</div>
          </div>
        ) : (
          <>
            <OperatorHeader
              collapsed={collapsed}
              setCollapsed={setCollapsed}
              broken={broken}
              currentMenu={currentMenu}
            />
            <div className={currentMenu === "inbox" ? "" : styles.outLetLayout}>
              {isAccess && <Outlet />}
              {/* <audio
                id="myAudio"
                ref={audioPlayer}
                src={sound}
                controlsList="nodownload"
                // autoPlay
                controls
                style={{ display: "none" }}
              /> */}
            </div>
          </>
        )}
        <ModalForm
          closeIcon={false}
          isOpen={isOpenModalNotice}
          onCancel={() => {
            setIsOpenModalNotice(false);
          }}
          title={renderTitle()}
          footer={false}
          customWidth={500}
        >
          <div style={{ marginTop: 20 }}>
            <Carousel
              autoplay
              className={`quill ${styles.carousel}`}
              dots={{ className: styles.dotSlide }}
            >
              {listNotice &&
                listNotice.length > 0 &&
                listNotice.map(notice => {
                  return (
                    <div key={notice.id} style={{ height: 500 }}>
                      <div
                        className="quill hiddenToolbar customScrollbar borderNone"
                        style={contentStyle}
                        dangerouslySetInnerHTML={{
                          __html: notice?.notice,
                        }}
                      />
                    </div>
                  );
                })}
            </Carousel>
          </div>
        </ModalForm>
      </Layout.Content>
    </Layout>
  );
};

export default HomeLayout;
